<template>
  <div>
    <h1 class="content__page-title">Сертификаты</h1>
    <div class="form-data form-data_type_ui_settings form-data_theme_bordered">
      <input type="text" class="price-range__input" name="query" v-model="searchQuery"
             placeholder="Введите ключевое слово">
      <div class="documents__list">
        <div class="documents__list-doc" v-for="key in paginatedData">
          <span class="action-link__text">{{ key.name }}</span>
          <div class="action-cert__text" v-html="key.certDetail"></div>
          <a :href="key.image" class="action-link action-link_weight" target="_blank">
            посмотреть
          </a>
        </div>
      </div>
      <div class="no-cert-mess" v-if="paginatedData.length == 0">К сожалению, сертификатов не найдено</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Certificates",
  props: {
    data: Array,

  },
  data: function () {
    var sortOrders = {},
        columns = [
          'id',
          'name',
          'detailText',
          'image'
        ]
    columns.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      sortKey: '',
      sortOrders: sortOrders,
      size: 20,
      pageNumber: 0,
      searchQuery: '',
    }
  },
  computed: {
    certificates() {
      return this.$store.getters.certificates;
    },
    paginatedData: function () {
      let result = this.certificates;

      var sQuery = this.searchQuery && this.searchQuery.toLowerCase();
      if (sQuery) {
        let newResult = {};
        for (let key in result) {
          let flag = false;
          for (let field in result[key]) {
            if (String(result[key][field]).toLowerCase().indexOf(sQuery) > -1) {
              flag = true;
              break;
            }
          }
          if (flag)
            newResult[key] = result[key];
        }
        result = newResult;
      }

      return result;
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
}
</script>

<style scoped>

</style>